<!--一体化教研-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--四个标签页：个人备课/协同备课/听评课/已发布备课-->
            <div class="tab-row">
                <edu-research-menu :item-num="activeItem" @change-item="changeItem"/>
                <!--新增按钮：个人备课/听评课，显示在最右边-->
                <el-button v-if="activeItem==='2'&&activeMode===pageMode" class="add-btn" @click="addLesson">新增备课</el-button>
                <el-button v-if="activeItem==='5'&&activeMode===pageMode" class="add-btn" @click="addEvaLesson">新增听评课</el-button>
            </div>
            <div class="module-content">
                <!--个人备课-->
                <edu-user-lesson v-if="activeItem==='2'"
                                 ref="userLesson"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                <!--协同备课-->
                <edu-team-lesson v-if="activeItem==='3'"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                <!--听评课-->
                <edu-eva-lesson v-if="activeItem==='5'"
                                ref="evaLesson"
                                :course-mode="this.activeMode"
                                @change-mode="changeMode"/>
                <!--已发布备课-->
                <edu-release-lesson v-if="activeItem==='4'"
                                    :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import eduResearchMenu from "@/components/eduResearch/eduResearchMenu.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import eduTeamLesson from "@/components/eduResearch/eduTeamLesson.vue";
import eduReleaseLesson from "@/components/eduResearch/eduReleaseLesson.vue";
import eduEvaLesson from "@/components/eduResearch/eduEvaLesson.vue";
export default {
    components: {
        homeHead,
        eduResearchMenu,
        eduUserLesson,
        eduTeamLesson,
        eduReleaseLesson,
        eduEvaLesson
    },
    name: "homeEduResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeEduResearch",
            activeItem:"2",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            if (item==='6'){
                window.open('https://orgzuoye.slilm.com/', '_blank')
                return;
            }
            this.activeItem = item;
            this.activeMode = this.pageMode;

        },
        changeMode(mode){
            this.activeMode = mode;
        },
        /*新增备课*/
        addLesson(){
            this.$refs.userLesson.addLesson();
        },
        /*新增听评课*/
        addEvaLesson(){
            this.$refs.evaLesson.addEvaLesson();
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
/*新增按钮，显示在最右边*/
.add-btn {
    min-width: 100px;
    height: 38px;
    margin-left: auto;
    border: none;
    border-radius: 19px;
    background-color: #f5a623;
    color: #fff;
    font-size: 15px;
}
.add-btn:hover,
.add-btn:focus {
    background-color: #e09512;
    color: #fff;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
</style>
